import React from 'react';

export const AddImage = () => (
    <>
        <path d='M15 8h.01'></path>
        <path d='M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5'></path>
        <path d='M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4'></path>
        <path d='M14 14l1 -1c.617 -.593 1.328 -.793 2.009 -.598'></path>
        <path d='M16 19h6'></path>
        <path d='M19 16v6'></path>
    </>
);